import http from './http'

export default {
    all() {
        return http.get(`ihm/prospectos`)
    },

    update(prospecto, { status }) {
        return http.put(`ihm/prospectos/${prospecto}`, { status })
    },

    addComment(prospecto, contenido) {
        return http.post(`hsbc/prospectos/${prospecto}/comentarios`, {
            contenido
        })
    },
}